// extracted by mini-css-extract-plugin
export default {"list":"DepositFundsConfirmModal_list__mN2IP","item":"DepositFundsConfirmModal_item__Bg3ij","value":"DepositFundsConfirmModal_value__R6j7n"};